/*
 * @Description:
 */
import { useStore } from '@/store'

export const checkPermission = (value: string[]): boolean => {
  if (value && value instanceof Array && value.length > 0) {
    const permissions = useStore().state.user.permission
    const permissionRoles = value
    const hasPermission = permissions.some(p => {
      return permissionRoles.includes(p)
    })
    return hasPermission
  } else {
    console.error('need roles! Like v-permission="[\'admin\',\'editor\']"')
    return false
  }
}
